<div> <button mat-icon-button [mat-dialog-close]="{cancel: true}" class="close-dialog">
    <mat-icon>close</mat-icon>
</button>
<h2 mat-dialog-title> {{action}} Client </h2>
<div class="mat-dialog-title-content">
    <div class="scroll-container">
        <eca-form-column>
            <form [formGroup]="form">
                <mat-form-field>
                    <mat-label>Client Code</mat-label>
                    <input matInput formControlName="code" required>
                    <mat-error>Client code is required</mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Title</mat-label>
                    <input matInput formControlName="title" required>
                    <mat-error>Title is required</mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Description</mat-label>
                    <textarea matInput formControlName="description" required></textarea>
                    <mat-error>Description is required</mat-error>
                </mat-form-field>
            </form>
        </eca-form-column>
        <label>Associate(d) Services</label>
        <mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="checked">
              <mat-header-cell *matHeaderCellDef>
                Select
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                <mat-checkbox [(ngModel)]="item.checked"></mat-checkbox>
              </mat-cell>
            </ng-container>
      
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef>
                Service Name
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                {{item.name}}
              </mat-cell>
            </ng-container>
      
            <ng-container matColumnDef="alias">
              <mat-header-cell *matHeaderCellDef>
                Service Alias (Client's specific name)
              </mat-header-cell>
              <mat-cell *matCellDef="let item">
                <mat-form-field>
                    <input matInput [(ngModel)]="item.alias">
                </mat-form-field>
              </mat-cell>
            </ng-container>      
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="{cancel: true}"> Cancel </button>
    <button mat-button color="primary" [mat-dialog-close]="{cancel: false, form: form, serviceList: serviceList}" [disabled]="form.invalid"> {{action}} Client </button>
</div>
</div>